import 'reflect-metadata';
import { BeforeInsert, Column, Entity, PrimaryGeneratedColumn, OneToMany } from 'typeorm';
import Images from './image.entity';
import { BaseEntite, EntiteStatique } from './index';

@EntiteStatique()
@Entity('fichier')
export class Fichier implements BaseEntite {
    static key = 'fichiers';
    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;
    @Column({ type: 'timestamp', nullable: true })
    created_at: string;

    base64?: string;

    @OneToMany(() => Images, (image: Images) => image.fichiers, { cascade: true })
    activites: Images[];

    @BeforeInsert()
    updateCreatedAt(): void {
        this.created_at = new Date().toUTCString();
    }
}
